@if (!hideLabel() && isXLScreen()) {
  <button
    mat-stroked-button
    (click)="onBackButtonClick($event)"
    data-cy="back-button"
    class="w-h-default-button gap--8"
    matTooltip="{{ labelTranslateKey() | translate | uppercase }}"
  >
    <mat-icon color="accent">arrow_back</mat-icon>
    {{ labelTranslateKey() | translate | uppercase }}
  </button>
} @else {
  <button
    mat-icon-button
    (click)="onBackButtonClick($event)"
    data-cy="back-button"
    class="w-h-default-button gap--8"
    matTooltip="{{ labelTranslateKey() | translate | uppercase }}"
  >
    <mat-icon color="accent">arrow_back</mat-icon>
  </button>
}
